import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ditu",
  "use": "icon-ditu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"icon-ditu\">\r\n<style type=\"text/css\">\r\n\t#icon-ditu .st0{fill:currentColor;}\r\n</style>\r\n<path class=\"st0\" d=\"M513,532.6c64.2,0,116.2-52.1,116.2-116.2c0-64.2-52.1-116.2-116.2-116.2s-116.2,52.1-116.2,116.2\r\n\tC396.7,480.5,448.8,532.6,513,532.6z M513,964.4c-63,0-332.2-348-332.2-531.4S329.6,100.8,513,100.8S845.2,249.5,845.2,433\r\n\tS576,964.4,513,964.4z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol